module.exports = __webpack_public_path__ + "img/overlay-bg-careers-mobile.51961339.svg";